import barkioDarkTheme from "src/styling/barkio-dark-theme";
import barkioLightTheme from "src/styling/barkio-light-theme";
import bibinoDarkTheme from "src/styling/bibino-dark-theme";
import bibinoLightTheme from "src/styling/bibino-light-theme";
import environment from "src/utils/environment";

const { appName } = environment;

export const themes = {
  "barkio-dark": barkioDarkTheme,
  "barkio-light": barkioLightTheme,
  "bibino-dark": bibinoDarkTheme,
  "bibino-light": bibinoLightTheme
};

export default function getNamedTheme(themeName = "light") {
  return themes[`${appName}-${themeName}`];
}
